import { PolicyName } from '@/types/enum';

export const policyMap = {
  [PolicyName.USER_AGREEMENT]: {
    title: 'basic-user-agreement',
    path: '/user-agreement',
  },
  [PolicyName.PRIVACY_POLICY]: {
    title: 'basic-privacy-policy',
    path: '/privacy-policy',
  },
  [PolicyName.MEMBERSHIP_AGREEMENT]: {
    title: '1LXimfArGeVi4fCKVtKa',
    path: '/membership-agreement',
  },
  [PolicyName.ANTI_ABUSE]: {
    title: 'iAjHkhm94xq4M7q72yGF',
    path: '/anti-abuse',
  },
  [PolicyName.CHILD_SEXUAL_ABUSE]: {
    title: 'pweJ9RndSd1sIzpoOsOwv',
    path: '/child-sexual-abuse',
  },
  [PolicyName.COPYRIGHT_INFRINGEMENT]: {
    title: 'xjcgYiATpZVlotKqGkyFz',
    path: '/copyright-Infringement',
  },
  [PolicyName.POLICY_UPDATES]: {
    title: 'un3RslMoF53r5OBYcez',
    path: '/update',
  },
}

export interface PolicyUpdate {
  date: string;
  name: PolicyName;
  hidden?: boolean
}
/* 更新步骤：
1、在下方版本列表里新增一条版本记录,date代表协议生效日期
2、在对应的协议目录新增一条名为yyyy-mm-ss.vue的协议，日期与此处新增的记录日期一致
3、在update目录下对应协议新增一条yyyy-mm-ss.vue更新记录，内容为change list
hidden字段:协议的初始版本不需要在更新页展示，但是需要跳转，此处使用hidden隐藏
---------------------------
4、如果有新的政策协议, 在项目部署之后的未来日期生效，那需要剔除ssg渲染模式，改为ssr渲染才能自动生效更新
   如果需要剔除ssg渲染模式，那需要修改nuxt.config.ts的ssgRoutes，剔除路由，改为ssr渲染的页面
   项目部署较为频繁，且协议更新频次较少，所以采用ssg渲染模式 也合适。
*/
export const versionList: PolicyUpdate[] = [
  { date: '2025-02-12', name: PolicyName.CHILD_SEXUAL_ABUSE },
  { date: '2023-11-06', name: PolicyName.PRIVACY_POLICY },
  { date: '2023-10-14', name: PolicyName.PRIVACY_POLICY },
  { date: '2023-08-23', name: PolicyName.MEMBERSHIP_AGREEMENT },
  { date: '2023-05-23', name: PolicyName.CHILD_SEXUAL_ABUSE, hidden: true },
  { date: '2022-06-14', name: PolicyName.MEMBERSHIP_AGREEMENT, hidden: true },
  { date: '2021-11-08', name: PolicyName.PRIVACY_POLICY, hidden: true },
]
